<template>
  <div class="drop-down-menu" @click.stop="showMenuHandel()">
    <div class="label">
      {{ filterOption(value) }}
      <i class="fa fa-angle-down" aria-hidden="true"></i>
    </div>
    <ul class="menu" v-show="showMenu">
      <li
        :class="{ active: value === item.value }"
        v-for="item in dropList"
        :key="item.value"
        @click.stop="choice(item)"
      >
        {{ item.label }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showMenu: false,
    };
  },
  mounted() {
    this.$nextTick(function () {
      if (this.value === "" && this.dropList[0]) {
        this.$emit("input", this.dropList[0].value);
      }
      document.addEventListener("click", this.closeMenu);
    });
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeMenu);
  },
  props: ["dropList", "value"],
  methods: {
    showMenuHandel() {
      if (this.showMenu) {
        document.body.click();
      } else {
        document.body.click();
        this.showMenu = !this.showMenu;
      }
    },
    closeMenu() {
      this.showMenu = false;
    },
    filterOption(value) {
      let str = "";
      this.dropList.forEach((item) => {
        if (item.value === value) {
          str = item.label;
        }
      });
      return str;
    },
    choice(item) {
      this.showMenu = false;
      this.$emit("input", item.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.drop-down-menu {
  user-select: none;
  display: flex;
  align-items: center;
  padding: 0 25px 0 15px;
  position: relative;
  background-color: var(--new-bg-white);
  height: 22px;
  border: 1px solid var(--new-border);
  z-index: 2;
  color: var(--new-text);
  font-size: 12px;
  cursor: pointer;
  .label {
    & > i {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .menu {
    position: absolute;
    left: 0;
    right: 0;
    top: 31px;
    max-height: 200px;
    overflow: auto;
    border: 1px solid var(--new-border);
    li {
      font-size: 12px;
      text-align: center;
      line-height: 32px;
      background-color: var(--new-bg-white);
      cursor: pointer;
      &:not(:nth-last-child(1)) {
        border-bottom: 1px solid var(--new-border);
      }
      &.active,
      &:hover {
        background-color: var(--new-bg-table-active);
        color: var(--new-text-primary-bg);
      }
    }
  }
}
</style>
